import { useQuery } from "@tanstack/react-query";
import { certificationService } from "@/services/certificationService";

export function useCertificationReport() {
  return useQuery({
    queryKey: ["certification", "report"],
    queryFn: certificationService.getReport,
  });
}
